import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

class HotelScroller extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current: 0,
    };
  }

  render() {
    const start = `${this.props.dates.start.place.city}, ${this.props.dates.start.place.state}`;
    const end = `${this.props.dates.end.place.city}, ${this.props.dates.end.place.state}`;
    return (
      <div className="hotel-scroller">
        <Button bsStyle="default" onClick={this.props.prev}>
          <i className="fa fa-chevron-left fa-lg" />
        </Button>
        <strong className="date-selector">
          {start} - {end}
        </strong>
        <Button bsStyle="default" onClick={this.props.next}>
          <i className="fa fa-chevron-right fa-lg" />
        </Button>
      </div>
    );
  }
}

HotelScroller.propTypes = {
  current: PropTypes.number.isRequired,
  end: PropTypes.number.isRequired,
  dates: PropTypes.object.isRequired,
  next: PropTypes.func.isRequired,
  prev: PropTypes.func.isRequired,
};
export default HotelScroller;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelScroller.js